<template>
  <div class="footer" :class="type != 0 ? 'packMode' : ''">
    <div class="top">
      <div class="contentBox">
        <div class="left">
          <img src="@/assets/images/logo/logo.png" alt="" />
          <p>
            <span style="font-size:16px">白鸽宝客服热线：</span> 400-9024-365
          </p>
        </div>
        <div class="right">
          <img src="@/assets/images/gzh.jpg" alt="" />
          <p>微信公众号</p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="contentBox" style="display: block">
        <!-- <p>
          本平台仅为互联网保险提供网络技术支持辅助服务。产品提供、产品销售、收取保费、理赔服务等行为，均由{{
            tit
          }}进行。
          <span @click="skip()" v-if="id">信息披露</span>
        </p> -->
        <div>
          <p>
            <span style="text-decoration: none;color: #fff;">©Copyright</span>
            <span style="text-decoration: none;color: #fff;">
              白鸽宝保险经纪有限公司
            </span>
          </p>
          <p style="margin-top: 5px;">
            <img
              style="margin-bottom: -2px;"
              src="https://cdn.baigebao.com/src/pc8.0/images/footer_ba_icon1.png"
              alt=""
            />
            互联网站ICP备案
            <a
              href="https://beian.miit.gov.cn/"
              style="color:#ff6a00"
              target="_blank"
              rel="noopener noreferrer"
            >
              闽ICP备15001111号
            </a>
            <span style="text-decoration: none;color: #fff;">
              <img
                style="margin-bottom: -2px;"
                src="https://cdn.baigebao.com/src/pc8.0/images/footer_ba_icon1.png"
                alt=""
              />互联网站公安备案 35020302001945
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "vFoote",
  props: {
    id: {
      type: [Number, String],
      default: ""
    },
    tit: {
      type: String,
      default: "锐鹿科技"
    },
    type: {
      type: [Number, String],
      default: "0"
    }
  },
  methods: {
    skip() {
      // 页面跳转
      this.$router.push({
        path: "/announce",
        query: { id: this.id }
      });
    }
  }
};
</script>
<style lang="scss">
.footer {
  width: 100%;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 100% 100%;
  background-image: url("~@/assets/images/layout/footerbg.png");
  .top {
    padding-top: 40px;
    height: 170px;
    border-bottom: 1px solid #fff3;
    .left {
      img {
        height: 42px;
      }
      img + p {
        font-size: 48px;
        font-weight: 600;
        color: #ffffff;
        line-height: 67px;
        margin: 0;
      }
      p + p {
        font-size: 20px;
        font-weight: 400;
        color: #e2e2e2;
        line-height: 28px;
        margin-bottom: 14px;
      }
    }
    .right {
      padding: 0 60px 0;
      img {
        width: 80px;
      }
      img + p {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
        margin: 5px 0 0;
      }
    }
  }
  .contentBox {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
  }
  .bottom {
    padding: 20px 0;
    text-align: center;
    p {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin: 0;
      span {
        color: #f8db07bf;
        text-decoration: underline;
        display: inline-block;
        margin-left: 25px;
        cursor: pointer;
      }
    }
  }
}
.footer.packMode {
  .top {
    display: none;
  }
  .bottom {
    padding: 15px 0;
  }
}
</style>
